export default __webpack_public_path__ + "0f3f239ccb6f7c17307ff51d63d7e7a2.png";